import React from 'react';
import moment from 'moment';
import { AlertCircle, TriangleAlert } from 'lucide-react';

export const RiskEvent = ({ event, OnRedirect ={} }) => {
  const getSeverityLevel = (severity) => {
    if (severity >= 17) return 'High';
    if (severity >= 9) return 'Moderate';
    if (severity >= 0) return 'Low';
    return '';
  };

  const getSeverityColor = (severity) => {
    if (severity >= 17) return "#C50F1F";
    if (severity >= 9) return "#EAA300";
    if (severity >= 0) return "#0B6A0B";
    return "";
  };

  const getStatusText = () => {
    switch (event.status) {
      case 0: return 'Identified';
      case 1: return 'Opened';
      case 2: return 'Monitoring';
      case 3: return 'Escalated';
      case 4: return 'Impacted';
      case 5: return 'Closed';
      default: return '';
    }
  };

  const getTypeText = () => {
    switch (event.type) {
      case 0: return 'Scope';
      case 1: return 'Schedule';
      case 2: return 'Budget';
      case 3: return 'Quality';
      case 4: return 'Resource';
      default: return '';
    }
  };

  const handleRedirection = () => {
    if (OnRedirect) {
      OnRedirect();
    }
  };

  return (
    <div
        onClick={() =>{handleRedirection()}} 
        className={`risk-event ${event.isIssue ? 'risk-event--issue' : 'risk-event--warning'}`}>
        <div className="risk-event__header">      
          <div className="risk-event__icon">
              {event.isIssue ? <AlertCircle /> : <TriangleAlert/>} 
          </div>
          <div className="risk-event__title-section">
            <h6 className="risk-event__title">{event.name}</h6>
            {event.project && (
              <span className="risk-event__project">{event.project.name}</span>
            )}
          </div>
          <div className="risk-event__badges">
            <span className={`risk-event__badge risk-event__badge--type`}>
              {getTypeText()}
            </span>
            <span 
              className="risk-event__badge risk-event__badge--severity"
              style={{ backgroundColor: getSeverityColor(event.severity), color: '#ffffff' }}
            >
              {getSeverityLevel(event.severity).toUpperCase()}
            </span>
            <span className={`risk-event__badge risk-event__badge--${getStatusText().toLowerCase().replace(' ', '-')}`}>
              {getStatusText()}
            </span>
          </div>
        </div>

        <div className="risk-event__details">
          {event.scope && (
            <div className="risk-event__scope">
              <strong>Affected Scope:</strong> {event.scope.name}
            </div>
          )}
          
          {event.task && (
            <div className="risk-event__task">
              <strong>Affected Task:</strong> {event.task.name}
            </div>
          )}
          
          <div className="risk-event__impact-date">
            <strong>Date Of Impact:</strong> {moment(event.dateImpact).format('MMM D, YYYY')}
          </div>
          {event.dateResolved && (
            <div className="risk-event__impact-date">
              <strong>Date Resolved:</strong> {moment(event.dateResolved).format('MMM D, YYYY')}
            </div>
          )
          }
        </div>
      </div>
  );
};